export const AdminAccessRequired = () => (
  <div className="px-md-4">
    <div className="row content p-4">
      <div className="col-12">
        <h4 className="text-center m-0">ADMIN ACCESS REQUIRED</h4>
      </div>
    </div>
  </div>
);
